<template>
  <div>
    <NumberHeader
        v-on:click.native="setActiveStep(1)"
        :number="number"
        :activeStep="activeStep"
        :title="'Reisgezelschap '"
        :subtitle="
                'Je begint opnieuw met het samenstellen van jouw cruise vakantie! De voorgaande zoekopdrachten en/of filters zijn hier niet in meegenomen.' +
                 ' Reis je met een baby, kind of meer personen? Wijzig dan hier het gezelschap en wij controleren de beschikbaarheid. ' +
                  'Let wel op: Je boekt online per hut. ' 

            "
    />
<div class="">
    <div class="notification-persons">
      <p>
        <b>Onderstaand reisgezelschap verblijft samen in één hut.</b> Wil je meerdere hutten boeken?
       Dan kan je na het bevestigen van deze boeking, het boekingsproces nogmaals doorlopen.
       </p>
    </div>
</div>

    <div v-if="isUnder25(payload.cabins[0].birthdates.volwassenen[0])">
      <div class="notification-persons">
        <p>
          <b>Let op:</b> De hoofdboeker is onder de 25 jaar oud. Mogelijk dat dit niet is toegestaan door de uitvoerder van de reis, {{cruise.rederij_naam}}. Bij sommige rederijen en vaargebieden gelden strengere regels. Je kunt de boeking wel afronden en wij zullen na boeking contact met je opnemen om dit te herbevestigen.
        </p>
      </div>
    </div>


    <CabinConfigActive
        :cruise="cruise"
        :activeStep="activeStep"
        :payload="payload"
        :setActiveStep="setActiveStep"
        :resetCabinConfig="resetCabinConfig"
        :changeCompany="changeCompany"
        :changeBirthdateCompany="changeBirthdateCompany"
        :setPeopleAndStep="setPeopleAndStep"
        :minAdult="minAdult"
    />

    <CabinConfigInactive
        :activeStep="activeStep"
        :payload="payload"
        :setActiveStep="setActiveStep"
    />
  </div>
</template>

<script>
import NumberHeader from './NumberHeader.vue'
import CabinConfigInactive from './CabinConfigStep/CabinConfigInactive.vue'
import CabinConfigActive from './CabinConfigStep/CabinConfigActive.vue'

export default {
  name: 'CabinConfigStep',
  components: {
    NumberHeader,
    CabinConfigActive,
    CabinConfigInactive,
  },
  methods: {
    isUnder25(dateOfBirth) {
      const today = new Date();
      const birthDate = new Date(dateOfBirth);
      const age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();
      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        return age - 1 < 25;
      }
      return age < 25;
    }
  },
  props: {
    number: Number,
    activeStep: Number,
    payload: Object,
    cruise: Object,
    resetCabinConfig: Function,
    setActiveStep: Function,
    setPeopleAndStep: Function,
    changeCompany: Function,
    changeBirthdateCompany: Function,
    title: String,
    subtitle: String,
    totalPax: Number,
    minAdult: Number,
  },
}
</script>

<style>

.notification-persons {
  margin: 13px 0 !important;
  background-color: #fff3cd;
  padding: 15px 15px 10px;
  border-radius: 5px;
  margin-left: 15px;
  border: 1px solid #fff3cd;
  font-size: 15px;
  display: flex;
  width: 1000px;
  max-width: 100%;
  position: relative;
 }

@media only screen and (max-width: 1200px) {
  .notification-persons {
    margin: 5px 20px !important;
    width: 90% !important;
  }
}



.notification-persons p {
  margin-top: 5px !important;
  color: #856404 !important;
}

p,
a,
div {
  color: #333333;
}
</style>